import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { meKey, useMe } from './api/auth';
import { Toaster } from './components/ui/toaster';
import { TooltipProvider } from './components/ui/tooltip';
import { AuthPage } from './features/auth/auth-page';
import { NotesPage } from './features/notes/notes-page';
import { useApplyTheme } from './hooks/use-theme';
import { AppLayout } from './layout/app-layout';
import { setUnauthorizedHandler } from './lib/api';
import { queryClient } from './lib/query-client';
import { paths } from './lib/routes';

// Session expirée pendant l'utilisation : on bascule sur l'écran de connexion.
setUnauthorizedHandler(() => {
  queryClient.clear();
  queryClient.setQueryData(meKey, null);
});

function ThemeSync() {
  const { data: me } = useMe();
  useApplyTheme(me?.preferences.theme);
  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path={paths.login} element={<AuthPage mode="login" />} />
      <Route path={paths.register} element={<AuthPage mode="register" />} />
      <Route element={<AppLayout />}>
        <Route index element={<NotesPage />} />
        <Route path="reminders" element={<NotesPage />} />
        <Route path="archive" element={<NotesPage />} />
        <Route path="trash" element={<NotesPage />} />
        <Route path="label/:labelId" element={<NotesPage />} />
        <Route path="search" element={<NotesPage />} />
        <Route path="*" element={<Navigate to={paths.notes} replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  useEffect(() => {
    document.documentElement.lang = 'fr';
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <ThemeSync />
          <AppRoutes />
          <Toaster />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
